import React from 'react';
import StarRateIcon from '@material-ui/icons/StarRate';
import './ProDetails.css';
import { useStateValue } from './StateProvider';
import Product from './Product';

function ProDetails({ id, title, image, price, rating }) {
    const [{basket}, dispatch] = useStateValue();

    const addToCart = () => {
        dispatch({
            type: 'ADD_TO_CART',
            item: {
                id: id,
                title: title,
                image: image,
                price: price,
                rating: rating
            },
        });
    };

    return (
        <div className="details_page">
            <Product 
                        id={id}
                        title="TCL 32-Inch TV"
                        price={14999}
                        image="https://m.media-amazon.com/images/I/71Ut6ZxFbpL._AC_UY218_.jpg"
                        rating={4}
                    />
            <div className="product_details">
            <div className="product_image">
                <img src={image} alt="product"/>
            </div>
            
            <div className="product_info">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do 
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut 
                    enim ad minim veniam, quis nostrud exercitation ullamco laboris 
                    nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor 
                    in reprehenderit in voluptate velit esse cillum dolore eu fugiat 
                    nulla pariatur. Excepteur sint occaecat cupidatat non proident, 
                    sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
                <p className="product_price">
                    Ksh.<strong>13500</strong>
                </p>

                <p className="product_rating">
                    {Array(rating).fill().map((_, i) => (
                    
                        <span><StarRateIcon/></span>
                    ))}
                </p>

                <button onClick={addToCart}>Add to Cart</button>
            </div>
            </div>

        </div>
    )
}

export default ProDetails ;
